export enum HTTP {
  OK = 200,
  OK_NO_CONTENT = 204,

  BAD_REQUEST = 400,
  FORBIDDEN = 401,
  PAYMENT_REQUIRED = 402,
  CONFLICT = 409,
  /** Authenticated but not allowed. `FORBIDDEN` above is really 401. */
  NOT_AUTHORIZED = 403,
  NOT_FOUND = 404,
  UNPROCESSABLE_ENTITY = 422,
  TOO_MANY_REQUESTS = 429,

  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503
}
